import React, { PropsWithChildren } from 'react';
import { VStack, Flex } from '@cad-arc';
import { FrPage } from '../fr-page-layout/fr-page';

type FrAttachmentsPageLayoutProps = {
    footer: React.ReactNode;
};

export function FrAttachmentsPageLayout({
    footer,
    children,
}: PropsWithChildren<FrAttachmentsPageLayoutProps>) {
    return (
        <FrPage>
            <Flex flex={1} px={4} pt={4} width="100%" minH={0}>
                <VStack spacing={4} flex={1} minW={0}>
                    {children}
                </VStack>
            </Flex>
            {footer}
        </FrPage>
    );
}
